var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 360942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00403 13.9998C3.19268 14.0246 0.0165642 10.865 6.48324e-05 7.03711C-0.0164345 3.20102 3.11844 0.0248949 6.92978 0.000145918C10.8071 -0.0246031 13.9667 3.10202 13.9997 6.98761C14.0327 10.8155 10.8814 13.9751 7.00403 13.9998ZM12.8778 6.99586C12.8778 3.77024 10.2296 1.1221 6.99578 1.13035C3.77841 1.13035 1.13852 3.77024 1.13027 6.97936C1.13027 10.238 3.76191 12.8779 7.02878 12.8696C10.2296 12.8696 12.8695 10.2132 12.8778 6.99586Z",
    fill: "white",
    fillOpacity: 0.93
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.1226 3.87334C6.11395 4.38351 6.50306 4.78127 7.01323 4.77262C7.50611 4.77262 7.88657 4.39216 7.88657 3.89928C7.89522 3.38047 7.51476 3 6.99594 3C6.50306 3.00865 6.13125 3.38047 6.1226 3.87334Z",
    fill: "white",
    fillOpacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.37329 9.58872C6.37329 9.68384 6.37329 9.77031 6.37329 9.86542C6.37329 10.0211 6.37329 10.1854 6.37329 10.341C6.37329 10.6436 6.49435 10.8598 6.70187 10.9463C6.77105 10.9809 6.85752 10.9982 6.95263 10.9982C7.30716 10.9982 7.54063 10.7647 7.54927 10.3497C7.54927 10.2805 7.54927 10.2113 7.54927 10.1421C7.54927 9.81354 7.55792 9.49361 7.55792 9.16502L7.63574 6.83035C7.63574 6.73523 7.63574 6.64876 7.63574 6.55365C7.63574 6.398 7.63574 6.23371 7.63574 6.07807C7.63574 5.77542 7.51468 5.55925 7.30716 5.47278C7.23798 5.43819 7.15151 5.4209 7.0564 5.4209C6.70187 5.4209 6.46841 5.65437 6.45976 6.06942C6.45976 6.13859 6.45976 6.20777 6.45976 6.27695C6.45976 6.60553 6.45111 6.92547 6.45111 7.25405L6.37329 9.58872Z",
    fill: "white",
    fillOpacity: 0.93
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.929c3d10238dd2b448ebd98c9bea3b67.svg";
export { ForwardRef as ReactComponent };